import { gql } from '@apollo/client';
import ItemFragment from './ItemFragment';
import UserCompanyFragment from './UserCompanyFragment';

const UserListItemFragment = gql`
	${ItemFragment}
	${UserCompanyFragment}

	fragment UserListItemFragment on User {
		_id
		name
		username
		url
		role
		company {
			...UserCompanyFragment
		}
		avatarURL
		isPro
		canFollow
		isFollowing
		isFollowingBack
		items(limit: 16) {
			items {
				...ItemFragment
			}
		}
	}
`;

export default UserListItemFragment;
